module.exports = __webpack_public_path__ + "img/ins.c36946b4.png";